const parseArrayField = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export const formatAmount = (value) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));

export const shortCurrency = (value) =>
  value ? String(value).split(" - ")[0].trim() : "-";

export const buildExchangeRateMap = (logisticDraft) => {
  const currencyArray = parseArrayField(logisticDraft?.currencies);

  return currencyArray.reduce((acc, currency) => {
    if (!currency?.name) return acc;

    const exactName = String(currency.name).trim();
    const shortName = shortCurrency(exactName);
    const rate = Number(currency.rate || 0);

    acc[exactName] = rate;
    acc[shortName] = rate;
    return acc;
  }, { INR: 1 });
};

export const getQuoteTotalsByCurrency = (quote) => {
  const totals = {};

  (quote?.quoteItems || []).forEach((item) => {
    const currency = item?.currency || "-";
    totals[currency] = (totals[currency] || 0) + (Number(item?.rate || 0) * Number(item?.quantity || 0));
  });

  return totals;
};

export const getQuoteTotalInInr = (quote, exchangeRateMap) =>
  (quote?.quoteItems || []).reduce((sum, item) => {
    const currency = item?.currency || "";
    const rate = Number(
      exchangeRateMap?.[currency] ??
        exchangeRateMap?.[shortCurrency(currency)] ??
        0
    );

    return sum + Number(item?.total || 0);
  }, 0);

export const buildVendorSummaryGroups = (quotes = []) => {
  const vendorGroups = new Map();

  quotes.forEach((quote) => {
    const vendorKey =
      quote.vendorEmail ||
      quote.vendorFirmName ||
      quote.vendorName ||
      quote.logisticQuoteId;

    if (!vendorGroups.has(vendorKey)) {
      vendorGroups.set(vendorKey, []);
    }

    vendorGroups.get(vendorKey).push(quote);
  });

  return Array.from(vendorGroups.values()).map((vendorQuotes) => {
    const sortedQuotes = vendorQuotes
      .slice()
      .sort(
        (a, b) =>
          new Date(a.createdDate || 0).getTime() -
          new Date(b.createdDate || 0).getTime()
      );

    const latestQuote = sortedQuotes[sortedQuotes.length - 1] || {};
    const vendorLabel =
      latestQuote.vendorFirmName ||
      latestQuote.vendorName ||
      latestQuote.vendorEmail ||
      "Vendor";

    return {
      vendorKey:
        latestQuote.vendorEmail ||
        latestQuote.vendorFirmName ||
        latestQuote.vendorName ||
        latestQuote.logisticQuoteId,
      vendorLabel,
      initialQuote: sortedQuotes[0] || null,
      finalQuote: sortedQuotes.length > 1 ? sortedQuotes[sortedQuotes.length - 1] : null,
    };
  });
};

export const getSummaryCurrencies = (quotes = []) =>
  [...new Set(quotes.flatMap((q) => q.quoteItems?.map((i) => i.currency) || []))].filter(Boolean);
